<div class="cart-popup-main">
    <div class="cart-popup">
        <div class="mat-dialog-actions" mat-dialog-actions [align]="selectedAlign">
            <button mat-button mat-dialog-close><mat-icon>close</mat-icon></button>
        </div>
        <div class="check-circle-cart">
            <mat-icon>check_circle</mat-icon>
            <h3>{{"shoppingCart.putMaterialIntoCart" | translate }}</h3>
        </div>
        <div  class="material">
            <div class="image">
                <img *ngIf="material" src="{{ material.url }}" />
                <img *ngIf="packagee" src="{{ packagee.imageUrl }}" />
            </div>
            <div class="author-title">
                <p *ngIf="material">{{material.author}}</p>
                <p class="package-name" *ngIf="packagee">{{packagee.packageName}}</p>
                <p *ngIf="material">{{material.title}}</p>
            </div>
        </div>
        <div class="back-and-to-buttons">
            <button (click)="closeDialog()" routerLink="/book">{{"shoppingCart.continueToBuy" | translate }}</button>
            <button (click)="closeDialog()" routerLink="/cartsum">{{"shoppingCart.goIntoCart" | translate }}</button>
        </div>
    </div>
</div>
